import React from 'react';
import { useDarkMode } from '../../stores/themeStore';

interface XTNDLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function XTNDLogo({ className = '', size = 'md' }: XTNDLogoProps) {
  const { isDark } = useDarkMode();
  
  const sizeClasses = {
    sm: 'h-6 w-auto',
    md: 'h-8 w-auto',
    lg: 'h-12 w-auto',
  };

  // Use dark mode logo when in dark mode
  const logoSrc = isDark ? '/xtnd-dark.png' : '/xtnd.png';

  return <img src={logoSrc} alt="XTND Logo" className={`${sizeClasses[size]} ${className}`} />;
}

export default XTNDLogo;
